<ng-container *ngIf="supplementary; let supplementary">
    <div fxFlex="1 1 100%" fxLayout="column" class="supplementary-container">
        <span>{{ supplementary.name }}</span>
        <a *ngIf="supplementary.resource[0]; let resource" (click)="downloadFile(resource)" class="underline-link">Download {{ resource.ext | uppercase | slice:1 }}</a>
    </div>
</ng-container>
